import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import CustomPrompt from '@/plugins/customPrompt';
import vuetify from './plugins/vuetify';
import SvgIcon from '@/components/SvgIcon.vue';

async function bootstrap() {
  const app = createApp(App);

  app.component('SvgIcon', SvgIcon);
  app.use(CustomPrompt);
  app.use(router);
  app.use(vuetify);

  await router.isReady();
  app.mount('#app');
}

bootstrap();
